import './_course-calender.scss'

// LIBS
import React from 'react'
import querystring from 'querystring'
import {sortBy, cloneDeep} from 'lodash/fp'
import axios from 'axios'

// COMPONENTS
import CourseCalendarFilter from '../../components/course-calendar-filter'
import CourseCalenderByYear from '../../components/course-calendar-year'
import MetaData from '../../components/meta-data'

// HELPERS
import courseSchedule from '../../data/code/course-schedule.json'
import {renderIf, familyToLegacyQueryStringCourseCodeMap, prepareSchedule, prepareRaw} from '../../lib/util.js'

const familyToFilterDisplayName = {
    'code-101': 'Code 101',
    'ops-101': 'Ops 101',
    'web3-101': 'Web3 101',
    'code-102': 'Code 102',
    'ops-102': 'Ops 102',
    'code-201': 'Code 201',
    'ops-201': 'Ops 201',
    'code-301': 'Code 301',
    'ops-301': 'Ops 301',
    'code-501': 'Code 501',
    'code-502': 'Code 502',
    'code-java-401': 'Code 401: Java',
    'code-python-401': 'Code 401: Python',
    'code-javascript-401': 'Code 401: JavaScript',
    'code-dotnet-401': 'Code 401: ASP.NET',
    'ops-cybersecurity-401': 'Ops 401: Cybersecurity',
    'ai-aitoolsforcoders-501': 'AI 501: AI Tools for Coders',
    'ai-aitoolsforprofessionals-501': 'AI 501: AI Tools for Professionals'

}

const getDefaultFilterDataFromFamily = (sequenceAndFamily) => ({
  displayName: familyToFilterDisplayName[sequenceAndFamily],
  queryFilterName: familyToLegacyQueryStringCourseCodeMap[sequenceAndFamily],
})

const trackDefaultHours = {
  '101': 'Saturday, 9 a.m. – 8 p.m.',
  '102': 'Monday - Friday, 6:30 - 9:30 p.m.',
  'day': 'Monday – Friday, 9 a.m. – 6 p.m.',
  'night': 'Monday – Thursday, 6:30 – 9:30 p.m; Saturday, 9:00 a.m. – 6:00 p.m.',
  'self-paced': 'Self-Paced Online Course.',
}

const prepareInPersonCities = (raw) => {
  // Capture all unique cities for In-Person and Hybrid courses
  let inPersonCitiesArray = raw.filter(course => {
    if(course.onlineVsInPerson === 'In-Person' || course.onlineVsInPerson === 'Hybrid') {
      return course.location
    }
  })
  .map(course => course.location.city)
  let inPersonCitiesSet = new Set(inPersonCitiesArray)
  let inPersonCitiesUnique = Array.from(inPersonCitiesSet);
  inPersonCitiesUnique.push('Online')

  return inPersonCitiesUnique
}

const prepareUniqueCities = (raw) => {
  // Capture all unique cities for all current courses
  let citiesArray = raw.filter(course => {
      return course.location
  })
  .map(course => course.location.city)
  let citiesSet = new Set(citiesArray)
  let uniqueCities = Array.from(citiesSet);
  uniqueCities.sort();

  let locations = [{
    'displayName': 'Online', 
    'queryFilterName': 'Online'
  }]

  uniqueCities.map(city => {
    return locations.push(
      {
        'displayName': city, 
        'queryFilterName': city
      }
    )
  })
  return locations
}

class CourseCalendar extends React.Component {
  constructor(props){
    super(props);
    let filterState = {
      'Program': {
        'Software Development': { displayName: 'Software Development', queryFilterName: 'code'},
        'Ops and Cybersecurity': { displayName: 'Ops and Cybersecurity', queryFilterName: 'ops'},
        'Web3': { displayName: 'Web3', queryFilterName: 'web3'},
        'AI': { displayName: 'AI', queryFilterName: 'ai' }
      },
      'Courses': { //Render as "Course Level"
        '100: Beginner': {
          open: false,
          courses: [
            getDefaultFilterDataFromFamily('code-101'),
            getDefaultFilterDataFromFamily('code-102'),
            getDefaultFilterDataFromFamily('ops-101'),
            getDefaultFilterDataFromFamily('ops-102'),
            getDefaultFilterDataFromFamily('web3-101')
          ],
        },
        '200: Foundations': {
          open: false,
          courses: [ 
            getDefaultFilterDataFromFamily('code-201'),
            getDefaultFilterDataFromFamily('ops-201')
          ],
        },
        '300: Intermediate': {
          open: false,
          courses: [ 
            getDefaultFilterDataFromFamily('code-301'),
            getDefaultFilterDataFromFamily('ops-301')
            ],
        },
        '400: Advanced': {
          open: false,
          courses: [
            getDefaultFilterDataFromFamily('code-javascript-401'),
            getDefaultFilterDataFromFamily('code-python-401'),
            getDefaultFilterDataFromFamily('code-java-401'),
            getDefaultFilterDataFromFamily('code-dotnet-401'),
            getDefaultFilterDataFromFamily('ops-cybersecurity-401')
          ],
        },
        '500: Continuing Education': {
          open: false,
          courses: [ 
            getDefaultFilterDataFromFamily('code-501'),
            getDefaultFilterDataFromFamily('code-502'),
            getDefaultFilterDataFromFamily('ai-aitoolsforcoders-501'),
            getDefaultFilterDataFromFamily('ai-aitoolsforprofessionals-501')
          ],
        },
      },
      'Start Date': {
        'q1': { displayName: 'Jan. — Mar.', queryFilterName: 'q1'},
        'q2': { displayName: 'Apr. — Jun.', queryFilterName: 'q2'},
        'q3': { displayName: 'Jul. — Sep.', queryFilterName: 'q3'},
        'q4': { displayName: 'Oct. — Dec.', queryFilterName: 'q4'},
      },
      'Schedule': {
        'day': { displayName: 'Daytime', queryFilterName: 'day'},
        'night': { displayName:'Nights & Weekends', queryFilterName: 'night'},
        'self-paced': { displayName:'Self-Paced', queryFilterName: 'self-paced'},
      },
      'Location': []
    }
    this.state = {
      selected: new Set(),
      filteredSchedule: [],
      schedule: prepareSchedule(courseSchedule, 'course'),
      filteredSchedule: prepareSchedule(courseSchedule, 'course'),
      filterState,
      emptyFilterState: cloneDeep(filterState),
      locationsState: [],
      inPersonCitiesState: [],
      designateLocationState: true
    }
  }

  componentWillMount = () => {
    return axios.get('https://s3-us-west-2.amazonaws.com/static.codefellows.org/courses/schedule.json?ts=' + Date.now())
    .then(result => {
      if(result.data && result.data.courses && result.data.courses.length){
        this.setState({schedule: prepareSchedule(result.data, 'course'), filteredSchedule: prepareSchedule(result.data, 'course'), locationsState: prepareUniqueCities(prepareRaw(result.data, 'course')), inPersonCitiesState: prepareInPersonCities(prepareRaw(result.data, 'course')), designateLocationState: result.data.designateLocation})
        this.filterSchedule(this.state.selected)
      }
    })
    .catch((err) => console.error('errrrr', err))
  }

  componentDidMount = () => {
    let {location} = this.props

    if(location.hash){
      // if the page has hash it should show the start and end date of the appropriate course listing
      setTimeout(() => scrollBy(0, -100), 0)
    }
    try {
      let filters = querystring.parse(location.search.slice(1)).filters || ''
      let filterSet =new Set(filters.split(','))
      this.filterSchedule(filterSet)
      this.setState(state => {
        let {Courses} = state.filterState
        Object.keys(Courses).forEach(key => {
          Courses[key].open = Courses[key].courses.reduce((r, n) => {
            return filterSet.has(n.queryFilterName) || r
          }, false)
        })
        return {
          filterState: {Courses, ...state.filterState},
          ...state,
        }
      })
    } catch (e) {
      //console.error('wat', e)
    }
  }

  clearFilters = () => {
    this.setState(state => ({selected: new Set(), filterState: cloneDeep(state.emptyFilterState)}))
    setTimeout(() => {
      this.filterSchedule(new Set())
      this.props.history.replace({search: ''})
    }, 0)
  }

  filterSchedule = (selected) =>  {
    this.setState(state => {
      let {schedule} = state

      let shouldFilterByQuarter = false
      let shouldFilterByTrack = false
      let shouldFilterByFamily = false
      let shouldFilterByProgram = false
      let shouldFilterByOnline = false
      let shouldFilterByCity = false
      
      // program
      if(selected.has('code') || selected.has('ops') || selected.has('web3') || selected.has('ai')) {
        shouldFilterByProgram = true
      }
      
      // quarters
      if(selected.has('q1') || selected.has('q2') || selected.has('q3') || selected.has('q4')) {
        shouldFilterByQuarter = true
      }
      
      // track
      if(selected.has('day') || selected.has('night') || selected.has('self-paced')){
        shouldFilterByTrack = true
      }
      
      // family
      shouldFilterByFamily = Object.values(familyToLegacyQueryStringCourseCodeMap).reduce((result, code) => {
        return result || selected.has(code)
      }, false)
      if(selected.has('100: Beginner') || selected.has('200: Foundations') || selected.has('300: Intermediate') || selected.has('400: Advanced') || selected.has('500: Continuing Education') ) {
        shouldFilterByFamily = true
      }
      
      // online
      if(selected.has('Online')){
        shouldFilterByOnline = true
      }
      
      // city
      state.locationsState.map(city => {
        if(city.queryFilterName !== 'Online' && selected.has(city.queryFilterName)) return shouldFilterByCity = true
      })

      // courseType
      let filteredSchedule = Array.from(schedule).filter(course => {
        let keep = true
        keep = shouldFilterByQuarter ? keep && selected.has(course.quarter) : keep // true if ByQuarter is true and course quarter is included in selection OR ByQuarter is false and preKeep ("previous Keep") is true
        keep = shouldFilterByTrack ? keep && selected.has(course.track) : keep //true if ByTrack is true and preKeep is true and course track is included in selection OR ByTrack is false and preKeep is True
        keep = shouldFilterByFamily ? keep && selected.has(course.queryStringFilterName) : keep //true if ByFamily is true and preKeep is true and family+sequence is included in selection OR ByFamily is false and preKeep is true
        keep = shouldFilterByProgram ? keep && selected.has(course.sequence) : keep //true if ByProgram is true and preKeep is true and course sequence is included in selection OR ByProgram is false and preKeep is true
        keep = shouldFilterByOnline ? keep && (selected.has(course.onlineVsInPerson) || selected.has(course.location.city) || course.onlineVsInPerson === 'Hybrid' || course.onlineVsInPerson === 'None') : keep //true if ByOnline is true and preKeep is true and (course OnlineInPerson or course city is included in selection or course.onlineVsInPerson is Hybrid) OR ByOnline is false and preKeep is true
        keep = shouldFilterByCity ? keep && ((selected.has(course.location.city) && (course.onlineVsInPerson === 'In-Person' || course.onlineVsInPerson === 'Hybrid')) || (selected.has('Online') && course.onlineVsInPerson === 'None') || selected.has(course.onlineVsInPerson)) : keep //true if ByCity is true and preKeep is true and (course city is included in selection (or course OnlineInPerson is Online or Hybrid) ) OR (filter by Online is true and onlineVsInPerson = None) OR ByCity is false and preKeep is true
        return keep
      })

      filteredSchedule = sortBy((course) => course.startDate, filteredSchedule)

      setTimeout(() => {
        let searchFilters = Array.from(selected).filter(i => i !== '').join(',')
        let search = searchFilters ? '?filters=' + searchFilters : ''
        this.props.history.replace({search, hash: this.props.location.hash})
      }, 0)

      return {...state, filteredSchedule, selected}
    })
  }

  selectFilter = (e) => {
    let {history, location} = this.props
    let filterName = e.target.value
    let selected = new Set(this.state.selected)
    if(selected.has(filterName)){
      selected.delete(filterName)
      this.filterSchedule(selected)
    } else {
      selected.add(filterName)
      this.filterSchedule(selected)
    }
  }

  toggleFilterSection = (event) => {
    let section = event.target.value
    this.setState(state => {
      let {selected} = state
      if(!selected.has(section)){
        selected.add(section)
      } else {
        selected.delete(section)
      }
      let copy = cloneDeep(state.filterState)
      let data  = copy.Courses[section]
      data.open = !data.open
      if(data.open){
        data.courses.forEach(course => selected.add(course.queryFilterName))
      } else {
        data.courses.forEach(course => selected.delete(course.queryFilterName))
      }
      setTimeout(() => this.filterSchedule(selected), 0)
      return {
        filterState: copy,
      }
    })
  }

  render(){
    return (
      <div>  
        <MetaData data={{
           slug: 'course-calendar',
           title: 'Coding & Developer Course Calendar | Code Fellows',
        }}/>
        <div className='custom_pages' style={{width: '100%', margin: 0}}>
          <header className="custom-page-header" >
            <h1>Courses</h1>
          </header>
          <div className='container'>
            <CourseCalendarFilter
               selected={this.state.selected}
               filterState={this.state.filterState}
               clearFilters={this.clearFilters}
               selectFilter={this.selectFilter}
               toggleFilterSection={this.toggleFilterSection}
               designateLocation={this.state.designateLocationState}
               locationsState={this.state.locationsState}
               inPersonCitiesState={this.state.inPersonCitiesState}
                />
            <div>
              <div className='calendar col-md-9'>
                <div className='course-calendar-items'>
                  {renderIf(!this.state.filteredSchedule.length,
                    <div>
                      <h3>Sorry! No classes match the selected filters.</h3>
                      <h4>Can't find the classes you're looking for?
                        <a href='https://learn.codefellows.org/contact?utm_audience=students&utm_promo_code=not_applicable&utm_sequence_type=not_applicable&utm_partner=0016100000M954d&utm_source=course_calendar_page-no_courses_published&utm_medium=website&utm_content=course_calendar_page-no_courses_published&utm_campaign=coding_for_beginners&utm_term=not_applicable&utm_campaign_id=not_applicable&utm_ad_id=not_applicable&utm_adset_id=not_applicable&utm_adset_name=not_applicable&utm_placement=not_applicable&utm_start=not_applicable&utm_cost=organic'> Contact&nbsp;Admissions&nbsp;»</a>
                      </h4>
                    </div>
                  )}
                  <CourseCalenderByYear 
                      courseSchedule={this.state.filteredSchedule}
                      designateLocation={this.state.designateLocationState}
                      />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CourseCalendar


// WEBPACK FOOTER //
// ./src/pages/course-calendar/index.js